var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "contests-error-dialog" },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c("h1", { staticClass: "error-dialog--heading" }, [
        _vm._v(_vm._s(_vm.$t("Contests.Error.Dialog.Heading")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "error-dialog--error-message" }, [
        _vm._v(_vm._s(_vm.errorMessage))
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "primary-btn btn--close-dialog",
          on: {
            click: function($event) {
              _vm.showDialog = false
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("Contests.Error.Dialog.Btn")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ad83fde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad83fde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestsErrorDialog.vue
// module id = null
// module chunks = 